import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { GameVariantConfigService } from "./game-variant.config";
import {
	BaseProviderParams,
	GameSettings,
	GameVariantDetail,
	GetGameSettingsParams,
	GetGameVariantParams,
	GetGameVariantQueryParams,
} from "./game-variant.model";

@Injectable({
	providedIn: "root",
})
export class GameVariantService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: GameVariantConfigService
	) {}

	get(params: GetGameVariantParams): Observable<GameVariantDetail<BaseProviderParams>> {
		const url = params.jurisdiction
			? this.config.getGameVariantByJurisdictionEndpoint()
			: this.config.getGameVariantEndpoint();

		return this.callGameVariant(url, params);
	}

	getSettings(params: GetGameSettingsParams): Observable<GameSettings> {
		return this.callGameSettings(this.config.getGameSettingsEndpoint(), params);
	}

	private callGameVariant(
		url: string,
		params: GetGameVariantParams
	): Observable<GameVariantDetail<BaseProviderParams>> {
		const queryParams: GetGameVariantQueryParams = {
			...params.searchParams,
			gameId: params.gameId,
			variantId: params.variantId,
		};
		return this.httpClient.get<GameVariantDetail<BaseProviderParams>>({
			url,
			searchParams: queryParams,
		});
	}

	private callGameSettings(url: string, params: GetGameSettingsParams): Observable<GameSettings> {
		return this.httpClient.get<GameSettings>({
			url,
			searchParams: {
				gameId: params.gameId,
			},
		});
	}
}
